import { getPermissions, getUserType, getOrgId } from '../misc/auth'

export default {
    // permissions: state => state.permissions || getPermissions(),
     //userType: state => state.userType || getUserType(),
     //userType: state => 'NOTISPHERE'
    // orgId: state => state.orgId || getOrgId()
}
